import React, { FC } from 'react';

const ConfettiBackground: FC = () => {
  return (
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 370 703">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#463C3C"
        d="M27.3,388.4c2.2,1.5,3.4,5.8,3.4,5.8c3.5,0,9.2,1,9.2,1c0-3.9-3.5-9.2-3.5-9.2S31.2,385,27.3,388.4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1C1B1A"
        d="M36.6,386.3c0,0-13.1-2.4-13.1,13.9c0,0-8.3-1-10-1c0,0-1.4-11.2,6.1-15.3C28.3,379.1,34.9,384.3,36.6,386.3"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C8BE02"
        d="M35.4,119.2c-0.1,2.4-2.7,5.5-2.7,5.5c1.8,2.8,3.9,7.8,3.9,7.8c3-1.9,5.3-7.3,5.3-7.3S40,120.5,35.4,119.2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FFF203"
        d="M41.9,125.5c0,0-5.1-11.8-16.8-4.3c0,0-3.6-7.2-4.5-8.6c0,0,7.3-6.3,14.2-2.1C42.8,115.4,42.4,123.2,41.9,125.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FFFFFF"
        d="M340.9,235.6c2.4-2.7,4.4-3.9,7.4-4.5c4.6-0.9,6.9-4.9,6.9-4.9l-6.4-8.5c-1.7,2.5-5.6,4.1-8.3,5.9
        C338.6,229.4,339.9,233.1,340.9,235.6z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B8B8B8"
        d="M341.1,223.2c0,0-11.4,5.2-6.1,16.4l8-1.7C343,237.8,338.3,232.7,341.1,223.2z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FFFFFF"
        d="M40.5,69.9c0,0-12.5-2.9-13.7-15.6l-6,5.2c0,0-2,11.8,12.7,19.2C33.5,78.8,40,70.2,40.5,69.9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B8B8B8"
        d="M20.8,59.4l0.4-0.3c1.4-0.8,5,0.4,5,0.4c-2.4,2-3.2,9.3-3.2,9.7C20,63.9,20.8,59.4,20.8,59.4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#463C3C"
        d="M24.3,188.1c0,0,6.6-13.6,24.6-7.4l-7.1-10.2C41.8,170.4,27.7,167,24.3,188.1"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1C1B1A"
        d="M35.3,179.6c-8.2,2-11.4,8.7-11.4,8.7c0-0.1,0-0.1,0-0.2c-1.8,3.8-4.1,4.5-4.1,4.5l9.3,4.9
        c2.2-2,4.8-6.6,4.7-11.2C33.6,182.4,34.9,180.2,35.3,179.6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FFF203"
        d="M13.7,242.4c0,0,12.8,3.8,10.2,20.4l7.7-7.8C31.6,255,32.4,242.1,13.7,242.4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C8BE02"
        d="M23.3,251.2c-2.9-6.9-9.2-8.7-9.2-8.7c0.1,0,0.1,0,0.2,0c-3.6-1-4.5-2.9-4.5-2.9L7,248.4
        c2.1,1.7,6.4,3.2,10.3,2.4C20.7,250.1,22.8,251,23.3,251.2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B8B8B8"
        d="M33.8,322.2c2,1.1,5.5,0.3,5.5,0.3c1.6,2.9,4.8,7.2,4.8,7.2c-2.7,1.7-8,1.1-8,1.1S33.1,326.9,33.8,322.2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FFFFFF"
        d="M36,330.6c0,0-7.3-9.7,3.8-16.7c0,0-4.2-6.4-5-7.8c0,0-8.2,3.7-7.8,11.6C27.6,326.9,34,330,36,330.6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C8BE02"
        d="M347.3,11c-2-1.4-4.1-5.3-4.1-5.3c-3.3,0-8.6-0.9-8.6-0.9c0,3.5,3.6,8.5,3.6,8.5S343.7,14.2,347.3,11z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FFF203"
        d="M338.2,13.3c0,0,12.7,2,12.7-12.8c0,0,8,0.9,9.7,0.9c0,0,1.4,10.2-5.9,13.9C346.2,19.6,339.9,15,338.2,13.3z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C8BE02"
        d="M60.7,2.1c-2.9-6.9-9.2-8.7-9.2-8.7c0.1,0,0.1,0,0.2,0c-3.6-1-4.5-2.9-4.5-2.9l-2.8,8.9
        c2.1,1.7,6.4,3.2,10.3,2.4C58.1,1.1,60.2,1.9,60.7,2.1"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FFF203"
        d="M51.1-6.7c0,0,12.8,3.8,10.2,20.4L69,5.9C69,5.9,69.8-7,51.1-6.7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#463C3C"
        d="M134.4,35.5c-2.9-2.5-4.2-4.6-4.8-7.7c-0.9-4.8-5.2-7.1-5.2-7.1l-8.9,6.7c2.6,1.8,3.2,4.7,5.3,8.2
        C127,37.4,131.8,36.5,134.4,35.5z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1C1B1A"
        d="M120.8,35.2c0,0,5.9,11,18.5,5.9l-2-7.8C137.3,33.4,131.5,38,120.8,35.2z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FFFFFF"
        d="M212.3,30.1c0,0,13.1,2.2,19-9.5l3.8,7.3c0,0-2.5,12.1-19.4,13.4C215.7,41.3,212.7,30.5,212.3,30.1"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B8B8B8"
        d="M235.1,28.3l-0.2-0.4c-1-1.3-4.9-1.6-4.9-1.6c1.5,2.8-0.3,10-0.4,10.3C234.2,32.9,235.1,28.3,235.1,28.3"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FFF203"
        d="M176.3,24.2l-5-8.4c0,0-1.3-5,5-9.6c6.3-4.6,6.3-7.5,6.3-12.1l5,8.4c0,0,0,5.9-3.3,8.4
        C180.9,13.4,176.3,15.5,176.3,24.2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FFFFFF"
        d="M357,74.1c-2.7-2.4-3.9-4.4-4.5-7.4c-0.9-4.6-4.9-6.9-4.9-6.9l-8.5,6.4c2.5,1.7,3.9,3.7,5.5,7.7
        C350.4,75.8,354.5,75.1,357,74.1z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B8B8B8"
        d="M344.6,73.9c0,0,5.2,11.4,16.4,6.1l-1.7-8C359.3,72,354.1,76.7,344.6,73.9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C8BE02"
        d="M335.9,122.9c1.9-2.4,3.5-3.5,5.9-4c3.6-0.8,5.5-4.3,5.5-4.3l-5.1-7.4c-1.4,2.2-3,3.1-6.3,4.6
        C334.4,116.9,335,120.8,335.9,122.9z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FFF203"
        d="M335.9,111.8c0,0-8.9,4.6-4.9,14.2l6.2-1.5C337.3,124.6,333.7,120,335.9,111.8z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#463C3C"
        d="M354.1,177.3c-1-4.1-0.8-6.8,0.6-9.9c2.2-4.8-0.1-9.6-0.1-9.6l-12.3,0.1c1.3,3.3,0.8,5.9-0.3,10.7
        C346.3,174.2,351.1,176.6,354.1,177.3z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1C1B1A"
        d="M341.9,168.5c0,0-1.7,13.2,12.9,16.9l3.2-8.1C358,177.4,349.9,177.9,341.9,168.5z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FFF203"
        d="M343.3,307.1l-5-8.4c0,0-1.3-5,5-9.6c6.3-4.6,6.3-7.5,6.3-12.1l5,8.4c0,0,0,5.9-3.3,8.4
        C347.9,296.2,343.3,298.3,343.3,307.1"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#463C3C"
        d="M286.3,14.4c2.1,1.5,3.4,5.8,3.4,5.8c3.5,0,9.2,1,9.2,1c0-3.9-3.5-9.2-3.5-9.2S290.2,10.9,286.3,14.4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1C1B1A"
        d="M295.6,12.2c0,0-13-2.4-13,13.9c0,0-8.3-1-10-1c0,0-1.4-11.2,6.1-15.3C287.4,5,293.9,10.3,295.6,12.2"
      />
    </svg>
  );
};

export default ConfettiBackground;
